import { UserAvatar } from "../../../common/components/avatar/userAvatar";
import { Crumb } from "../../../common/components/progress_status";
import { textChooser } from "../../../common/util/textChooser";
import { ProfileSummary } from "../../profile/profileSummary";
import "./overview.scss";

export const Overview = () => {
    return(
        <div className="application-summary">
            <div className="applicant-info">
                <div className="title">
                    <Crumb status={true} percentage={0} />
                    <h3>{textChooser("txt146")}</h3>
                </div>
                <UserAvatar size={"lg"} squared/>
            </div>
            
            <div className="row">
                <div className="col-xs-12 col-md-5">
                    <ProfileSummary/>
                </div>  
            </div>
        </div>
    )
}